import { render } from "./QrPayView.vue?vue&type=template&id=1af2579a"
import script from "./QrPayView.vue?vue&type=script&lang=js"
export * from "./QrPayView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__